import { render, staticRenderFns } from "./sustainabilitymodal.vue?vue&type=template&id=484e4f92"
import script from "./sustainabilitymodal.vue?vue&type=script&lang=js"
export * from "./sustainabilitymodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports